export class WebsitePricingIntervalsDTO {

   monthly: number;

   yearly: number;

}
